var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeedometer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speedometer2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5C11.3797 5.5 11.6875 5.8078 11.6875 6.1875V8.25C11.6875 8.6297 11.3797 8.9375 11 8.9375C10.6203 8.9375 10.3125 8.6297 10.3125 8.25V6.1875C10.3125 5.8078 10.6203 5.5 11 5.5Z",
    fill: "#005182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13182 7.88182C5.40031 7.61333 5.83561 7.61333 6.10409 7.88182L7.36114 9.13886C7.62962 9.40735 7.62962 9.84265 7.36114 10.1111C7.09265 10.3796 6.65735 10.3796 6.38886 10.1111L5.13182 8.85409C4.86334 8.58561 4.86334 8.1503 5.13182 7.88182Z",
    fill: "#005182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 13.75C2.75 13.3703 3.0578 13.0625 3.4375 13.0625H5.61796C5.99765 13.0625 6.30546 13.3703 6.30546 13.75C6.30546 14.1297 5.99765 14.4375 5.61796 14.4375H3.4375C3.0578 14.4375 2.75 14.1297 2.75 13.75Z",
    fill: "#005182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 13.75C15.8125 13.3703 16.1203 13.0625 16.5 13.0625H18.5625C18.9422 13.0625 19.25 13.3703 19.25 13.75C19.25 14.1297 18.9422 14.4375 18.5625 14.4375H16.5C16.1203 14.4375 15.8125 14.1297 15.8125 13.75Z",
    fill: "#005182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8497 7.91206C16.6524 7.71476 16.3365 7.7025 16.1245 7.88392L10.3775 12.802C9.82365 13.276 9.79085 14.1212 10.3063 14.6367C10.8336 15.164 11.7023 15.1156 12.1678 14.533L16.8893 8.62335C17.0592 8.41076 17.0421 8.10447 16.8497 7.91206Z",
    fill: "#005182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.75C0 7.67487 4.92487 2.75 11 2.75C17.0751 2.75 22 7.67487 22 13.75C22 15.0317 21.7805 16.2635 21.3765 17.4092C20.7689 19.1323 18.8407 19.6122 17.3452 19.1276C15.5502 18.5459 13.0269 17.875 11 17.875C8.97311 17.875 6.44985 18.5459 4.65479 19.1276C3.15932 19.6122 1.23109 19.1323 0.623467 17.4092C0.219477 16.2635 0 15.0317 0 13.75ZM11 4.125C5.68426 4.125 1.375 8.43426 1.375 13.75C1.375 14.8737 1.56729 15.9511 1.9202 16.9519C2.19937 17.7435 3.18971 18.1569 4.23091 17.8195C6.04466 17.2318 8.74278 16.5 11 16.5C13.2572 16.5 15.9553 17.2318 17.7691 17.8195C18.8103 18.1569 19.8006 17.7435 20.0798 16.9519C20.4327 15.9511 20.625 14.8737 20.625 13.75C20.625 8.43426 16.3157 4.125 11 4.125Z",
    fill: "#005182"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer);
export default __webpack_public_path__ + "static/media/Speedometer.80d6e4f9f5e0e0c06a89e751c9d43411.svg";
export { ForwardRef as ReactComponent };